(typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}).SENTRY_RELEASE = {
  id: "71fb0b643d60ee10a1d470534efb0c4352b556b8"
};